module.exports = __webpack_public_path__ + "img/index-ico4.b0384785.png";